import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

const selectAppDrawerVisibility = function (state: ApplicationRootState) {
  return state.appDrawerState || initialState;
};

const makeSelectVisibility = () =>
  createSelector(selectAppDrawerVisibility, substate => substate.visibility);

export { selectAppDrawerVisibility, makeSelectVisibility };
